// MOB M1-0: mobil uygulama (Capacitor, HepyApp-Mobil) içinde mi çalışıyoruz — tek kaynak.
// Web tarayıcısında her zaman false; davranış farkları (Google girişi, sağlayıcı konsolu) buna bakar.
import { Capacitor } from '@capacitor/core';
import { reactive } from 'vue';

export const yerelUygulama = Capacitor.isNativePlatform();

// MOB M1-1: canlı güncelleme durumu (services/mobilGuncelleme). nativeEski = kurulu APK,
// surum.txt'deki enDusukNative'den eski → router yalnız /yeni-surum-kurun'a izin verir.
export const mobilDurum = reactive({ nativeEski: false, apk: '' });

// MOB M2-b: auth.service logout'u mobilPush'a bağımlı olmadan çağırsın diye (web paketine eklenti girmez).
export const mobilKancalar = { cikis: null };
